import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  makeStyles,
  Paper,
} from "@material-ui/core";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useForm, Controller } from "react-hook-form";

const useStyles = makeStyles({
  container: { minHeight: "90vh", padding: 20 },
  paper: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 30,
    paddingRight: 30,
  },
  registerButton: { marginRight: 10, height: 50, flexGrow: 1 },
  backButton: { height: 50 },
  buttonsContainer: { marginTop: 20, marginBottom: 10 },
  textFields: { marginTop: 10 },
  title: { fontSize: 35, fontWeight: 800, marginTop: 5 },
});

export default function Register() {
  const classes = useStyles();
  const [registerDoneDialogOpen, setRegisterDoneDialogOpen] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors },
  } = useForm();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const emptyTextError = "فیلد نمیتواند خالی باشد.";

  const handleRegisterDoneDialogClose = () => {
    setRegisterDoneDialogOpen(false);
    navigate("/login");
  };

  const handleSubmitRegisterData = (data) => {
    setRegisterLoading(true);
    axios
      .post(process.env.REACT_APP_API_URL + "/signup", data)
      .then((res) => {
        if (res.status === 201) setRegisterDoneDialogOpen(true);
      })
      .catch((error) => {
        if (typeof error.response.data.errors.username !== "undefined") {
          if (error.response.data.errors.username[0] === "The username has already been taken.") {
            enqueueSnackbar("نام کاربری توسط شخص دیگری انتخاب شده است!", {
              variant: "error",
            });
          }
        }
      })
      .finally(() => {
        setRegisterLoading(false);
      });
  };

  return (
    <Grid container direction='column' className={classes.container}>
      <Dialog
        open={registerDoneDialogOpen}
        onClose={handleRegisterDoneDialogClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle>پایان ثبت نام</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ثبت نام شما با موفقیت انجام شد و پس از تایید مدیر میتوانید وارد سایت شوید.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRegisterDoneDialogClose} color='primary'>
            بستن
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container justifyContent='center' alignItems='center'>
        <Grid item xs={12} sm={8} md={5} lg={4}>
          <Paper className={classes.paper}>
            <Typography className={classes.title}>ثبت نام</Typography>

            <Controller
              name='first_name'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.first_name}
                  helperText={errors.first_name && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  label='نام'
                  margin='dense'
                  fullWidth
                />
              )}
            />

            <Controller
              name='last_name'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.last_name}
                  helperText={errors.last_name && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  margin='dense'
                  label='نام خانوادگی'
                  fullWidth
                />
              )}
            />
            <Controller
              name='phone_number'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.phone_number}
                  helperText={errors.phone_number && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  margin='dense'
                  label='شماره همراه'
                  fullWidth
                />
              )}
            />

            <Controller
              name='work_title'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.work_title}
                  helperText={errors.work_title && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  margin='dense'
                  label='عنوان محل کار'
                  fullWidth
                />
              )}
            />

            <Controller
              name='work_address'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.work_address}
                  helperText={errors.work_address && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  margin='dense'
                  label='آدرس محل کار'
                  fullWidth
                />
              )}
            />

            <Controller
              name='work_number'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.work_number}
                  helperText={errors.work_number && emptyTextError}
                  className={classes.textFields}
                  variant='outlined'
                  margin='dense'
                  label='شماره تماس محل کار'
                  fullWidth
                />
              )}
            />

            <Controller
              name='username'
              control={control}
              rules={{
                required: true,
                pattern: /^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.username}
                  helperText={
                    errors?.username?.type === "required"
                      ? emptyTextError
                      : errors?.username?.type === "pattern"
                      ? "نام کاربری نامعتبر"
                      : "حداقل ۸ کاراکتر و حداکثر ۲۰ کاراکتر و شامل کاراکتر های a-z, A-z, 0-9 باشد."
                  }
                  className={classes.textFields}
                  variant='outlined'
                  label='نام کاربری'
                  margin='dense'
                  fullWidth
                />
              )}
            />

            <Controller
              name='password'
              control={control}
              rules={{
                required: true,
                minLength: 6,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.password}
                  helperText={
                    errors?.password?.type === "required"
                      ? emptyTextError
                      : errors?.password?.type === "minLength" && "رمز عبور باید حداقل ۶ کارکتر باشد"
                  }
                  className={classes.textFields}
                  variant='outlined'
                  label='رمز عبور'
                  margin='dense'
                  fullWidth
                  type='password'
                />
              )}
            />

            <Controller
              name='password_confirmation'
              control={control}
              as={TextField}
              rules={{
                required: true,
                validate: (value) => getValues("password") === value,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={errors.password_confirmation}
                  helperText={
                    errors?.password_confirmation?.type === "required"
                      ? emptyTextError
                      : errors?.password_confirmation?.type === "validate" && "رمز عبور با تکرارش همخوانی ندارد."
                  }
                  className={classes.textFields}
                  variant='outlined'
                  label='تکرار رمز عبور'
                  margin='dense'
                  fullWidth
                  type='password'
                />
              )}
            />

            <Grid container direction='row' className={classes.buttonsContainer}>
              <Button
                color='secondary'
                size='large'
                variant='contained'
                className={classes.registerButton}
                disabled={registerLoading}
                onClick={handleSubmit(handleSubmitRegisterData)}
              >
                {registerLoading ? <CircularProgress size={24} /> : "ثبت نام"}
              </Button>

              <Button
                color='secondary'
                size='large'
                className={classes.backButton}
                component={Link}
                to='/login'
                variant='text'
              >
                بازگشت
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}
